import React from 'react';
import { Card, Typography, Grid, Box, Checkbox, FormControlLabel } from '@mui/material';

import { TextToTypography } from '../pages/TextPage';

import { InHouseCardHeader, InHouseCardContent } from '../components/CustomMUI';
import { useAppCommands } from '../appCore/AppRuntimeReact';
import AsyncActionButton, { AsyncActionButtonAbortError } from '../components/AsyncActionButton';

const TandCForm: React.FC = () => {
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);
  const checkboxRef = React.useRef<HTMLInputElement | null>(null);
  const { submitTermsAcceptance } = useAppCommands();

  const submitTerms = async () => {
    if (!checkboxRef.current?.checked) {
      setErrorMessage('You must agree to the Terms and Conditions.');
      throw new AsyncActionButtonAbortError();
    }

    setErrorMessage(null);
    await submitTermsAcceptance();
  };

  return (
    <Card variant="outlined"  style={{ margin: '0 auto'}}>
      <InHouseCardHeader title="Terms and Conditions" />
        <InHouseCardContent style={{  padding: '10px'  }}> 

          <Typography variant="cardSubtitle" component="div" style={{ marginBottom: '1em' }}>
          Please read our Terms and Conditions
          </Typography>   
          
            <Box
              height="200px" 
              overflow="auto"
              maxWidth="550px"
              border={1}
              padding={1}
              marginY={2}
            >
              <TextToTypography filename='text/terms-and-conditions.txt'/>
            </Box>
            <form>
                <Grid container direction="column" spacing={2}>
                    <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              defaultChecked={false}
                              inputRef={checkboxRef}
                              name="agree"
                              onChange={(event) => {
                                if (event.target.checked) {
                                  setErrorMessage(null);
                                }
                              }}
                            />
                          }
                          label="I agree to the Terms and Conditions"
                        />
                        {errorMessage && <div>{errorMessage}</div>}
                    </Grid>
                    <Grid item xs={12}  sx={{textAlign:'center'}}>
                        <AsyncActionButton
                          errorToast="Error"
                          idleLabel="Submit"
                          onAction={() => submitTerms()}
                          pendingLabel="Submitting..."
                          styleVariant="green"
                          successLabel="Accepted"
                        />
                    </Grid>
                </Grid>
            </form>
        </InHouseCardContent>
    </Card>
  );
};

export default TandCForm;
